module.exports = __webpack_public_path__ + "static/media/vec-znas-vec-veljas.7075dbe7.png";